//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { Trans, withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Testimonial } from '@cmp/common';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class TestimonialSection extends React.Component {
  render() {
    const { t } = this.props;

    const testimonials = [
      {
        text: t('landing_Testimonial1Text'),
        name: t('landing_Testimonial1Name'),
        role: t('landing_Testimonial1Role'),
        hospital: t('landing_Testimonial1Hospital'),
        location: t('landing_Testimonial1Location'),
      },
      {
        text: t('landing_Testimonial2Text'),
        name: t('landing_Testimonial2Name'),
        role: t('landing_Testimonial2Role'),
        hospital: t('landing_Testimonial2Hospital'),
        location: t('landing_Testimonial2Location'),
      },
    ];

    return (
      <div className={styles.Testimonials}>
        <div className={styles.TestimonialsContent}>
          <div className={styles.TestimonialsList}>
            {testimonials.map((testimonial, index) => (
              <Testimonial
                key={`testimonial-${index}`}
                testimonial={testimonial}
                className={styles.Testimonial}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(TestimonialSection);
